import React, { useState } from 'react';

import { graphql } from 'gatsby';

//@ts-ignore
import * as styles from './jump-to-topic.module.css';
import { KontentStringValue } from '../../../types/KontentProps';
import Button from '../Global/Button';

type Topic = {
    elements: {
        display_title: KontentStringValue;
        anchor_point: KontentStringValue;
    };
};

interface Props {
    topic_page_points: { value: Topic[] };
    cta_label?: KontentStringValue;
    headline: KontentStringValue;
    list_default_value: KontentStringValue;
}

const JumpToTopic: React.FC<Props> = ({
    topic_page_points,
    cta_label,
    headline,
    list_default_value,
}) => {
    const [selectedAnchorPoint, setSelectedAnchorPoint] = useState('');

    const handleAnchorChange = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        setSelectedAnchorPoint(event.target.value);
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.selectContainer}>
                <label htmlFor="anchors">
                    {headline.value || 'Jump To Topic'}
                </label>
                <div className="select-wrapper">
                    <select
                        name="anchors"
                        id="anchor"
                        value={selectedAnchorPoint}
                        onChange={handleAnchorChange}
                    >
                        <option value="" disabled selected>
                            {list_default_value.value || 'Jump To Topic'}
                        </option>
                        {topic_page_points.value.map(
                            (topic: Topic, idx: number) => {
                                return (
                                    <option
                                        key={idx}
                                        value={
                                            topic.elements.anchor_point.value
                                        }
                                    >
                                        {topic.elements.display_title.value}
                                    </option>
                                );
                            }
                        )}
                    </select>
                </div>
            </div>
            <div className={styles.ctaContainer}>
                <Button
                    type="button"
                    visualStyle="outlineDark"
                    onClick={() => {
                        window.location.hash = selectedAnchorPoint;
                    }}
                >
                    {cta_label?.value || 'Go'}
                </Button>
            </div>
        </div>
    );
};

export default JumpToTopic;

export const fragmentJumpToTopic = graphql`
    fragment JumpToTopic on kontent_item_component___jump_to_topic {
        elements {
            headline {
                value
            }
            list_default_value {
                value
            }
            topic_page_points {
                value {
                    ... on kontent_item_content_item___topic {
                        id
                        elements {
                            display_title {
                                value
                            }
                            anchor_point {
                                value
                            }
                        }
                    }
                }
            }
            cta_label {
                value
            }
        }
    }
`;
